import React, { useState, useEffect, useRef } from 'react';
import { Loading } from 'react-style-guide';
import { withTranslations, WithTranslationsProps } from 'react-utilities';
import { TGameData } from '../common/types/bedev1Types';
import GameCarousel from '../common/components/GameCarousel';
import { TBuildEventProperties } from '../common/components/GameTileUtils';
import { pageContext } from '../common/constants/eventStreamConstants';
import metadataConstants from '../gameDetails/constants/metadataConstants';
import bedev1Services from '../common/services/bedev1Services';
import useGameImpressionCarouselTracker from '../common/hooks/useGameImpressionCarouselTracker';
import { FeatureGameDetails } from '../common/constants/translationConstants';
import configConstants from '../common/constants/configConstants';
import recommendedGamesTranslationConfig from './translation.config';

export const RecommendedGamesCarousel = ({
  translate
}: {
  translate: WithTranslationsProps['translate'];
}): JSX.Element => {
  const carouselRef = useRef<HTMLDivElement>(null);
  const tileRef = useRef<HTMLDivElement>(null);
  const [gameData, setGameData] = useState<TGameData[]>([]);
  const { universeId = '' } = metadataConstants.metadataData() || {};
  const [isLoading, setIsLoading] = useState(false);
  const buildEventProperties: TBuildEventProperties = (data, id) => ({
    placeId: data.placeId,
    universeId: data.universeId,
    isAd: data.isShowSponsoredLabel,
    position: id,
    numberOfLoadedTiles: (gameData || []).length,
    page: pageContext.gameDetailPage
  });

  useGameImpressionCarouselTracker(carouselRef, tileRef, gameData, {
    sortPos: 0,
    page: pageContext.gameDetailPage
  });

  const fetchGameRecommendations = async () => {
    setIsLoading(true);
    try {
      const { games } = await bedev1Services.getGameRecommendations(
        universeId,
        configConstants.gameDetailsPage.maxTilesPerCarouselPage
      );
      setGameData(games);
    } catch (error) {
      console.error(error);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    // eslint-disable-next-line no-void
    void fetchGameRecommendations();
  }, []);
  return (
    <React.Fragment>
      {isLoading ? <Loading /> : null}
      {gameData.length > 0 && (
        <React.Fragment>
          <h3>{translate(FeatureGameDetails.HeadingRecommendedGames)}</h3>
          <GameCarousel
            ref={carouselRef}
            tileRef={tileRef}
            gameData={gameData}
            buildEventProperties={buildEventProperties}
            translate={translate}
          />
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default withTranslations<{}>(RecommendedGamesCarousel, recommendedGamesTranslationConfig);
